import { render, staticRenderFns } from "./epidemiologies.vue?vue&type=template&id=37ed5cc6&scoped=true"
import script from "./epidemiologies.vue?vue&type=script&lang=js"
export * from "./epidemiologies.vue?vue&type=script&lang=js"
import style0 from "./epidemiologies.vue?vue&type=style&index=0&id=37ed5cc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ed5cc6",
  null
  
)

export default component.exports